import React, { Component } from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import DollarMax from './commonDetails/DollarMax'
import DeductibleItems from './commonDetails/DeductibleItems'
import Coinsurance from './commonDetails/Coinsurance'
import Copay from './commonDetails/Copay'
import UnitMax from './commonDetails/UnitMax'
import CollapsibleSection from '../../../controls/CollapsibleSection'
import Loading from '../../../widgets/Loading'
import Card from '@material-ui/core/Card'
import { localize } from '../../../util/Localizer'
import { connect } from 'react-redux'
import { fetchDetails } from '../../../redux/actions/benefitDetailsActions'
import { injectIntl } from 'react-intl'
import NoResultsMsg from '../../../widgets/common/NoResultsMsg'
import CardStyles from '../../../styles/cards'
import { withStyles } from '@material-ui/core/styles'
import ErrorMessage from '../../../widgets/common/ErrorMessage'

class BenefitDetails extends Component {
  constructor () {
    super()
    this.state = {
      expandedKey: undefined
    }
  }
  componentDidMount () {
    this.props.fetchDetails(this.props.memberSummary.id, this.props.typeId, this.props.dependentId)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.dependentId !== this.props.dependentId) {
      this.props.fetchDetails(this.props.memberSummary.id, this.props.typeId, this.props.dependentId)
    }
  }

  handlePanelExpandedChanged = panelKey => (event, expanded) => this.setState({ expandedKey: expanded ? panelKey : false })

  renderDeductible (detailsData, props) {
    if (detailsData.deductibleItems.length > 0) {
      const { classes = {} } = this.props
      return (
        <Card className={ classnames(classes.summaryCard, classes.baseCard, classes.bottomMargin) }>
          <CollapsibleSection
            id='deductibleItems'
            showMuiBorder={false}
            heading={localize('pages.benefitDetails.deductible.title')}
            expanded={this.state.expandedKey === 'deductibleItems'}
            onExpanded={this.handlePanelExpandedChanged('deductibleItems')}>
            <Row>
              <Col xs={12} className='clearPLR'>
                { detailsData.deductibleItems.length > 0 ? (
                  detailsData.deductibleItems.map((item, i) => { return <DeductibleItems key={i} data={item} index={i} /> })
                ) : (
                  <NoResultsMsg message={localize('pages.benefitDetails.deductible.empty')} />
                )
                }
              </Col>
            </Row>
          </CollapsibleSection>
        </Card>
      )
    }
  }

  renderCopay (detailsData, props) {
    if (detailsData.coPayItems.length > 0) {
      const { classes = {} } = this.props
      return (
        <Card className={ classnames(classes.summaryCard, classes.baseCard, classes.bottomMargin) }>
          <CollapsibleSection
            id='coPay'
            showMuiBorder={false}
            heading={localize('pages.benefitDetails.coPay.title')}
            expanded={this.state.expandedKey === 'coPay'}
            onExpanded={this.handlePanelExpandedChanged('coPay')}>
            <Row>
              <Col xs={12} className='clearPLR'>
                <Copay data={detailsData.coPayItems} />
              </Col>
            </Row>
          </CollapsibleSection>
        </Card>
      )
    }
  }

  render () {
    const props = this.props
    const { detailsData = {}, classes = {}, pageLoading, error } = props
    // create the thing to render
    const ret = (
      <Row>
        <Col xs={12}>
          {!pageLoading && Object.keys(detailsData).length > 0 && (
            <div className='benefitDetailsPage'>
              <h3 className='sectionHeading'>{detailsData.benefitDescription}</h3>
              <Card className={ classnames(classes.summaryCard, classes.baseCard, classes.bottomMargin) }>
                {/* Coinsurance */}
                <CollapsibleSection
                  id='coinsurance'
                  showMuiBorder={false}
                  heading={localize('pages.benefitDetails.coinsurance.title')}
                  expanded={this.state.expandedKey === 'coinsurance'}
                  onExpanded={this.handlePanelExpandedChanged('coinsurance')} >
                  <Row>
                    <Col xs={12}>
                      <Coinsurance data={detailsData.coInsuranceList} />
                    </Col>
                  </Row>
                </CollapsibleSection>
              </Card>

              {/* Copay */}
              {this.renderCopay(detailsData, props)}

              <Card className={ classnames(classes.summaryCard, classes.baseCard, classes.bottomMargin) }>
                {/* Dollar Max */}
                <CollapsibleSection
                  id='dollarMax'
                  showMuiBorder={false}
                  heading={localize('pages.benefitDetails.dollarMax.title')}
                  expanded={this.state.expandedKey === 'dollarMax'}
                  onExpanded={this.handlePanelExpandedChanged('dollarMax')}>
                  <Row>
                    <Col xs={12} className='clearPLR'>
                      { detailsData.dollarMaximumList.length > 0 ? (
                        detailsData.dollarMaximumList.map((item, i) => { return <DollarMax key={i} data={item} index={i} /> })
                      ) : (
                        <NoResultsMsg message={localize('pages.benefitDetails.dollarMax.empty')} />
                      )
                      }
                    </Col>
                  </Row>
                </CollapsibleSection>
              </Card>

              {/*  render the deductible section */}
              {this.renderDeductible(detailsData, props)}

              <Card className={ classnames(classes.summaryCard, classes.baseCard, classes.bottomMargin) }>
                {/* Unit Max */}
                <CollapsibleSection
                  id='unitMax'
                  showMuiBorder={false}
                  heading={localize('pages.benefitDetails.unitMax.title')}
                  expanded={this.state.expandedKey === 'unitMax'}
                  onExpanded={this.handlePanelExpandedChanged('unitMax')}>
                  <Row>
                    <Col xs={12} className='clearPLR'>
                      <UnitMax data={detailsData.unitMaximumList} />
                    </Col>
                  </Row>
                </CollapsibleSection>
              </Card>
            </div>
          )}
          {pageLoading && <Loading message={localize('common.loadingContent')} /> }
          {error && <div className='benefitDetailsPage'><ErrorMessage error={error}/></div>}
        </Col>
      </Row>
    )

    return ret
  }
}

function mapStateToProps (state) {
  return {
    pageLoading: state.BenefitDetailsReducer.isFetching,
    detailsData: state.BenefitDetailsReducer.detailsData,
    memberSummary: state.memberSummaryReducer.memberSummary,
    searchObj: state.BenefitDetailsReducer.searchObj,
    error: state.BenefitDetailsReducer.error
  }
}

const ConnectedBenefitDetails = connect(mapStateToProps, { fetchDetails })(injectIntl(BenefitDetails))

const styles = {
  ...CardStyles,
  bottomMargin: {
    marginBottom: 25
  }
}

export default withStyles(styles)(ConnectedBenefitDetails)



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/BenefitDetails.js